import React from "react";

const Services = () => {
  const offers = [
    {
      category: "Website and Mobile",
      items: [
        "Web Development",
        "Custom Software",
        "CX Consulting Services",
        "MVP (Minimum Viable Product)",
        "Mobile App Development",
        "Web App Development",
        "Hybrid App Development",
        "Native App Development",
        "CMS Development"
      ]
    },
    {
      category: "Data & AI",
      items: [
        "Generative AI Integration",
        "Machine Learning Models",
        "Predictive Analytics",
        "AI Chatbot Implementation",
        "AI Agent Development",
        "Sentiment Analysis",
        "Custom AI Model Development"
      ]
    },
    {
      category: "UI/UX Design",
      items: [
        "User Research & Testing",
        "Interaction Design",
        "Visual Design Systems",
        "Accessibility Design (WCAG)",
        "Premium Design Systems",
        "Voice User Interface (VUI)",
        "Microinteractions Design",
        "Design Thinking Facilitation"
      ]
    },
    {
      category: "CRM and E Commerce",
      items: [
        "E Commerce Web Development",
        "E Commerce App Development",
        "Odoo ERP Customization",
        "CRM – Customer Relationship Management",
        "ERP – Enterprise Resource Planning",
        "LMS – Learning Management System",
        "SCM – Supply Chain Management",
        "CMS – Content Management System",
        "WMS – Warehouse Management System",
        "OMS – Order Management System",
        "FMS – Field Management System",
        "HRM & Internal Tool Development"
      ]
    }
  ];

  return (
    <>
      <style>{`
        #services .box {
          margin-bottom: 24px;
          background: rgba(255, 255, 255, 0.04) !important;
          border: 1px solid rgba(255, 255, 255, 0.08) !important;
          border-radius: 12px;
          padding: 22px 24px;
          transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
        }
        #services .box:hover {
          background: rgba(255, 255, 255, 0.08) !important;
          border-color: #007bff !important;
          transform: translateY(-8px);
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4);
        }
        #services .box .icon {
          margin-bottom: 12px;
        }
        #services .box .icon-img {
          width: 50px;
          height: 50px;
          transition: transform 0.4s ease;
        }
        #services .box:hover .icon-img {
          transform: scale(1.1) rotate(6deg);
        }
        #services .box .title {
          font-weight: 700;
          margin-bottom: 8px;
          font-size: 19px;
        }
        #services .box .title a {
          color: #ffffff !important;
          transition: color 0.3s;
        }
        #services .box .title a:hover {
          color: #007bff !important;
        }
        #services .box .description {
          font-size: 14px;
          line-height: 1.6;
          color: #b2b8c9 !important;
          margin-bottom: 0;
        }
        .what-we-offer-section {
          margin-top: 30px;
          padding-top: 20px;
        }
        .what-we-offer-title {
          font-size: 28px;
          color: #ffffff;
          font-weight: 600;
          margin-bottom: 30px;
          text-align: left;
        }
        .offer-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
        }
        .offer-column {
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.06);
          border-radius: 8px;
          padding: 16px 14px;
          transition: all 0.3s ease;
          min-width: 0;
        }
        .offer-column:hover {
          background: rgba(255, 255, 255, 0.05);
          border-color: #007bff;
          transform: translateY(-4px);
        }
        .offer-category {
          font-size: 17px;
          color: #ffffff;
          font-weight: 700;
          margin-bottom: 15px;
          padding-bottom: 8px;
          border-bottom: 2px solid #007bff;
        }
        .offer-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .offer-item {
          color: #b2b8c9;
          font-size: 12.5px;
          padding: 4px 0;
          display: flex;
          align-items: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          transition: all 0.2s ease;
        }
        .offer-item::before {
          content: "•";
          color: #007bff;
          font-weight: bold;
          display: inline-block;
          width: 1em;
          margin-left: 2px;
          margin-right: 6px;
          flex-shrink: 0;
        }
        .offer-column:hover .offer-item:hover {
          color: #ffffff;
          transform: translateX(4px);
        }
        @media (max-width: 991px) {
          .offer-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
          }
        }
        @media (max-width: 767px) {
          .offer-grid {
            grid-template-columns: 1fr;
            gap: 16px;
          }
          .offer-column {
            padding: 18px 16px;
          }
          .offer-item {
            font-size: 13.5px;
            white-space: normal;
            word-break: break-word;
          }
        }
      `}</style>

      {/*==========================
        Services Section
      ============================*/}
      <section id="services" className="section-bg" style={{ padding: "80px 0" }}>
        <div className="container">
          <header className="section-header">
            <h3>Services</h3>
            <p>
              We are committed to providing premium digital experiences and software engineering solutions to our clients.
            </p>
          </header>

          <div className="row mt-5">
            {/* Card 1: AI Development */}
            <div
              className="col-md-6 col-lg-5 offset-lg-1 wow bounceInUp"
              data-wow-duration="1.4s"
            >
              <div className="box">
                <div className="icon">
                  <img src="img/services/icon-web-designing.svg" className="icon-img" alt="AI Development" />
                </div>
                <h4 className="title">
                  <a href="" onClick={(e) => e.preventDefault()}>AI Development</a>
                </h4>
                <p className="description">
                  Transforming businesses with AI-powered applications that automate processes, analyze data, and deliver smarter, faster, and more efficient solutions.
                </p>
              </div>
            </div>

            {/* Card 2: Website Development */}
            <div
              className="col-md-6 col-lg-5 wow bounceInUp"
              data-wow-duration="1.4s"
            >
              <div className="box">
                <div className="icon">
                  <img src="img/services/icon-web-development.svg" className="icon-img" alt="Website Development" />
                </div>
                <h4 className="title">
                  <a href="" id="website_development" onClick={(e) => e.preventDefault()}>Website Development</a>
                </h4>
                <p className="description">
                  Empowering your online presence with tailored web solutions, from sleek designs to seamless functionality, ensuring your digital footprint leaves a lasting impression.
                </p>
              </div>
            </div>

            {/* Card 3: Mobile App Development */}
            <div
              className="col-md-6 col-lg-5 offset-lg-1 wow bounceInUp"
              data-wow-delay="0.1s"
              data-wow-duration="1.4s"
            >
              <div className="box">
                <div className="icon">
                  <img src="img/services/icon-app-development.svg" className="icon-img" alt="Mobile App Development" />
                </div>
                <h4 className="title">
                  <a href="" onClick={(e) => e.preventDefault()}>Mobile App Development</a>
                </h4>
                <p className="description">
                  Delivering native and hybrid mobile experiences across iOS (iPhone) and Android, blending innovation with intuitive design to deliver an outstanding mobile experience.
                </p>
              </div>
            </div>

            {/* Card 4: CRM and E Commerce */}
            <div
              className="col-md-6 col-lg-5 wow bounceInUp"
              data-wow-delay="0.1s"
              data-wow-duration="1.4s"
            >
              <div className="box">
                <div className="icon">
                  <img src="img/services/icon-comp-sales-service.svg" className="icon-img" alt="CRM and E Commerce" />
                </div>
                <h4 className="title">
                  <a href="" onClick={(e) => e.preventDefault()}>CRM and E Commerce</a>
                </h4>
                <p className="description">
                  Providing integrated business platforms including custom CRM dashboards, custom ERP system workflows (like Odoo), and high-performance e-commerce storefronts designed to scale.
                </p>
              </div>
            </div>
          </div>

          <div className="what-we-offer-section wow fadeInUp" data-wow-delay="0.2s">
            <div className="offer-grid">
              {offers.map((offer, idx) => (
                <div key={idx} className="offer-column">
                  <div className="offer-category">{offer.category}</div>
                  <ul className="offer-list">
                    {offer.items.map((item, itemIdx) => {
                      const hasSpacerBefore = item.startsWith("CRM \u2013") || item.startsWith("WMS \u2013");
                      return (
                        <li
                          key={itemIdx}
                          className="offer-item"
                          style={hasSpacerBefore ? { marginTop: "10px" } : {}}
                        >
                          {item}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          {/* HIDDEN SERVICES (Hidden but kept in file) */}
          <div style={{ display: "none" }} aria-hidden="true">
            {/* Digital Marketing */}
            <div className="box">
              <div className="icon">
                <img src="img/services/icon-digital-marketing.svg" className="icon-img" alt="" />
              </div>
              <h4 className="title">
                <a href="">Digital Marketing</a>
              </h4>
              <p className="description">
                Transform your online presence with our comprehensive digital marketing solutions. From search engine optimization (SEO) and pay-per-click (PPC) advertising to social media management and content marketing.
              </p>
            </div>

            {/* Online Training */}
            <div className="box">
              <div className="icon">
                <img src="img/services/icon-online-training.svg" className="icon-img" alt="" />
              </div>
              <h4 className="title">
                <a href="" id="online_trainings">Online Training</a>
              </h4>
              <p className="description">
                We are available for online batches using Zoom calls to unlock the power of technology through comprehensive online training in Node.js, Python, PHP, React, React Native, HTML, CSS, JavaScript, and TypeScript.
              </p>
            </div>

            {/* Computer Sales and Services */}
            <div className="box">
              <div className="icon">
                <img src="img/services/icon-comp-sales-service.svg" className="icon-img" alt="" />
              </div>
              <h4 className="title">
                <a href="">Computer Sales and Services</a>
              </h4>
              <p className="description">
                Discover the perfect blend of reliability and performance with our range of computer and laptop sales and services.
              </p>
            </div>

            {/* iPhone Mobile App Development */}
            <div className="box">
              <div className="icon">
                <img src="img/services/icon-iphone-mob-app-devl.svg" className="icon-img" alt="" />
              </div>
              <h4 className="title">
                <a href="">iPhone Mobile App Development</a>
              </h4>
              <p className="description">
                Elevating user engagement with custom iOS app development.
              </p>
            </div>

            {/* Android Mobile App Development */}
            <div className="box">
              <div className="icon">
                <img src="img/services/icon-app-development.svg" className="icon-img" alt="" />
              </div>
              <h4 className="title">
                <a href="">Android Mobile App Development</a>
              </h4>
              <p className="description">
                Enhancing user interaction through tailor-made Android app development.
              </p>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default Services;